/*
 * File: App.tsx
 * Project: rosita
 * -----
 * Last Modified: 18 Feb 2022 3:20:12 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { BackTop, Layout } from 'antd';
import { Loader } from 'components/common/Loader';
import { PageHeader } from 'components/common/PageHeader';
import { PageSubHeader } from 'components/common/PageSubHeader';
import { BusinessList } from 'components/organisms/BusinessList';
import { useAuthentication } from 'hooks/useAuthentication';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from 'redux/store';
import { MainRoutes } from 'routes/MainRoutes';
import { InlineStylesModel } from './models/InlineStylesModel';

const { Header, Content } = Layout;
const styles: InlineStylesModel = {
  layout: {
    height: '100vh'
  },
  header: {
    lineHeight: 1,
    display: 'flex',
    padding: 0,
    justifyContent: 'center'
  },
  content: {
    padding: '10px 50px',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 1920,
    alignSelf: 'center',
    width: '100%'
  },
  somethingWrong: {
    textAlign: 'center',
    height: '100vh'
  }
};

export const App = (): JSX.Element => {
  const location = useLocation();
  const { company } = useAppSelector((state) => state.app);
  const { accessToken, isLoading } = useAuthentication();

  if (isLoading || accessToken === null) {
    return <Loader />;
  }

  return (
    <React.StrictMode>
      <Layout style={styles.layout}>
        <BackTop />
        <Header style={styles.header}>
          <PageHeader />
        </Header>
        {location.pathname !== '/about' && location.pathname !== '/profile' && company ? <PageSubHeader /> : null}
        <Content style={styles.content}>
          {location.pathname === '/about' || location.pathname === '/profile' || company ? (
            <>
              <MainRoutes />
            </>
          ) : (
            <BusinessList />
          )}
        </Content>
      </Layout>
    </React.StrictMode>
  );
};
